import React from 'react';

const Error403 = () => {
  return (
    <div
      className="
    flex
    items-center
    justify-center
    w-screen
    h-screen
    bg-gradient-to-r
    from-indigo-600
    to-blue-400
  "
    >
      <div className="px-40 py-20 bg-white rounded-md shadow-xl">
        <div className="flex flex-col items-center">
          <h1 className="font-bold text-blue-600 text-9xl">403</h1>

          <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            <span className="text-red-500">Oops!</span> ACCESS FORBIDDEN
          </h6>

          <a href="/" className="px-6 py-2 text-sm font-semibold text-blue-800 bg-blue-100">Go home</a>
        </div>
      </div>
    </div>
  );
};

export default Error403;
